import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Button from 'components/button'

export default class OfferPreviewSwitch extends Component {
  constructor(props) {
    super(props)
    this.state = {
      type: props.type
    }
  }

  handleClick(type) {
    const { onButtonClick } = this.props

    this.setState({
      type
    })
    onButtonClick(type)
  }

  render() {
    const { type } = this.state
    const className = 'btn btn-outline'

    return (
      <div className={classnames('btn-group', `is-${type}`)}>
        <Button className={className} isSelected={type === 'pc'} onClick={() => this.handleClick('pc')}>
          {I18n.t('components.offer_preview_switch.button.desktop')}
        </Button>
        <Button className={className} isSelected={type === 'sp'} onClick={() => this.handleClick('sp')}>
          {I18n.t('components.offer_preview_switch.button.mobile')}
        </Button>
      </div>
    )
  }
}

OfferPreviewSwitch.propTypes = {
  type: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func.isRequired
}
